import React from 'react';
import ReactDOM from 'react-dom';
import Temp from './components/weather/Temp.js';

ReactDOM.render(
  <>
    <Temp />
  </>,
  document.getElementById('root')
);

